export default __webpack_public_path__ + "static/media/competition-card-img-1.4149478b.png";